
import React from 'react';
import { Doctor, Staff, Room, ScheduleItem, Appointment, Task } from './SchedulerTypes';
import ScheduleModal from './ScheduleModal';
import { Reassignment } from './ConflictResolutionModal';
import AppointmentModal from './AppointmentModal';
import TaskModal from './TaskModal';

interface DailyViewModalsProps {
  // Schedule Modal
  isScheduleModalOpen: boolean;
  onCloseScheduleModal: () => void;
  onSaveSchedule: (scheduleData: Partial<ScheduleItem>, reassignments?: Reassignment[]) => void;
  onDeleteSchedule: (scheduleId: string) => void;
  onDeleteSeries?: (ids: string[]) => void;
  onCreateAppointment: (appointmentData: Omit<Appointment, 'id' | 'createdAt' | 'updatedAt'>) => void;
  editingItem: ScheduleItem | null;
  defaultStartTime: string;
  currentDate: Date;
  selectedPersonId?: string;
  selectedIsDoctor?: boolean;
  
  // Appointment Modal
  isAppointmentModalOpen: boolean;
  onCloseAppointmentModal: () => void;
  onSaveAppointment: (appointmentData: Omit<Appointment, 'id' | 'createdAt' | 'updatedAt'>) => void;
  selectedScheduleForAppointment: ScheduleItem | null;
  editingAppointment: Appointment | null;
  
  // Task Modal
  isTaskModalOpen: boolean;
  onCloseTaskModal: () => void;
  onSaveTask: (taskData: Omit<Task, 'id' | 'createdAt' | 'updatedAt'>) => void;
  selectedScheduleForTask: ScheduleItem | null;
  editingTask: Task | null;
  
  // Data
  doctors: Doctor[];
  staff: Staff[];
  rooms: Room[];
  scheduleItems?: ScheduleItem[];
}

const DailyViewModals = ({
  isScheduleModalOpen,
  onCloseScheduleModal,
  onSaveSchedule,
  onDeleteSchedule,
  onDeleteSeries,
  onCreateAppointment,
  editingItem,
  defaultStartTime,
  currentDate,
  selectedPersonId,
  selectedIsDoctor,
  isAppointmentModalOpen,
  onCloseAppointmentModal,
  onSaveAppointment,
  selectedScheduleForAppointment,
  editingAppointment,
  isTaskModalOpen,
  onCloseTaskModal,
  onSaveTask,
  selectedScheduleForTask,
  editingTask,
  doctors,
  staff,
  rooms,
  scheduleItems = [],
}: DailyViewModalsProps) => {
  return (
    <>
      <ScheduleModal
        isOpen={isScheduleModalOpen}
        onClose={onCloseScheduleModal}
        onSave={onSaveSchedule}
        onDelete={onDeleteSchedule}
        onDeleteSeries={onDeleteSeries}
        onCreateAppointment={onCreateAppointment}
        doctors={doctors}
        staff={staff}
        rooms={rooms}
        initialData={editingItem}
        defaultStartTime={defaultStartTime}
        currentDate={currentDate}
        selectedPersonId={selectedPersonId}
        selectedIsDoctor={selectedIsDoctor}
        scheduleItems={scheduleItems}
      />

      {selectedScheduleForAppointment && (
        <AppointmentModal
          isOpen={isAppointmentModalOpen}
          onClose={onCloseAppointmentModal}
          onSave={onSaveAppointment}
          scheduleItem={selectedScheduleForAppointment}
          existingAppointment={editingAppointment}
          doctors={doctors}
          staff={staff}
          rooms={rooms}
        />
      )}

      {selectedScheduleForTask && (
        <TaskModal
          isOpen={isTaskModalOpen}
          onClose={onCloseTaskModal}
          onSave={onSaveTask}
          scheduleItem={selectedScheduleForTask}
          existingTask={editingTask}
          doctors={doctors}
          staff={staff}
          rooms={rooms}
        />
      )}
    </>
  );
};

export default DailyViewModals;
